const LIST_PATH = '/admin/committeeMember';

/** List URL for a chapter / About Us tab. */
export const committeeMemberListUrl = (params) => {
  const type = params?.get?.('type') ?? params?.type;
  const search = new URLSearchParams();

  if (type === 'about_us') {
    search.set('type', 'about_us');
    const aboutUsType = params?.get?.('about_us_type') ?? params?.about_us_type;
    if (aboutUsType) search.set('about_us_type', String(aboutUsType));
  } else if (type === 'chapter') {
    search.set('type', 'chapter');
    const chapterId =
      params?.get?.('local_chapter_id') ?? params?.local_chapter_id;
    if (chapterId != null && chapterId !== '') {
      search.set('local_chapter_id', String(chapterId));
    }
  }

  const qs = search.toString();
  return qs ? `${LIST_PATH}?${qs}` : LIST_PATH;
};

/** After create/update, land on the section matching the saved member. */
export const committeeMemberListUrlFromFormData = (formData) => {
  const type = formData?.get?.('type');
  if (type === 'about_us') {
    return committeeMemberListUrl({
      type: 'about_us',
      about_us_type: formData.get('about_us_type'),
    });
  }
  return committeeMemberListUrl({
    type: 'chapter',
    local_chapter_id: formData?.get?.('local_chapter_id'),
  });
};

/** Carry active tab query onto add/edit routes. */
export const committeeMemberFormUrl = (subPath, listQueryString) => {
  const path = `${LIST_PATH}/${subPath}`;
  return listQueryString ? `${path}?${listQueryString}` : path;
};
